import { SelectOption } from "@/flokit/compound/inputs/select/base";
import { Select } from "@/flokit/compound/inputs/select/select";

export const SingleSelectEdit = (props: {
  options: SelectOption[];
  value: SelectOption;
  onChange: (value: SelectOption) => void;
  label: string;
  subText: string;
  isRequired: boolean;
  validationMessage?: string;
  shouldShowValidation: boolean;
  onBlur: () => void;
  isInModal?: boolean;
}) => {
  return (
    <div className="space-y-2">
      <Select
        {...props}
        isMulti={false}
        options={props.options}
        value={props.value}
        isRequired={props.isRequired}
        isClearable
        onChange={(v) => {
          props.onChange(v);
        }}
        shouldShowValidation={props.shouldShowValidation}
        description={props.subText}
        label={props.label}
        placeholder="-Select Answer-"
        isInModal={props.isInModal}
      />
    </div>
  );
};
